<div>
  <div class="bg-primary-light">
    <div class="container text-center py-14 lg:py-16">
      <h1 class="text-3xl lg:text-4xl font-semibold mb-1 text-main-900">{{ 'HAIRSTYLES.TITLE' | translate }}</h1>
      <p class="mb-5">{{ 'HAIRSTYLES.SUBTITLE' | translate }}</p>
      <form [formGroup]="searchHairstyleForm" (ngSubmit)="onSubmitForm()"
        class="border-2 border-main-500 bg-white py-4 px-3 lg:py-2.5 rounded-lg mx-auto w-full lg:w-fit">
        <div class="flex flex-col lg:flex-row gap-2">
          <div class="flex flex-1 relative">
            <input type="text" name="hairstyle" id="hairstyle"
              [placeholder]="'HAIRSTYLES.HAIRSTYLE_PLACEHOLDER' | translate" class="h-11 pl-9 pr-4 focus:outline-none"
              formControlName="hairstyle">
            <div class="absolute top-1/2 -translate-y-1/2 left-2.5">
              <icon-search [size]="18" />
            </div>
          </div>
          <div class="flex flex-1 relative">
            <input type="number" name="price" id="price" [placeholder]="'HAIRSTYLES.MAX_PRICE_PLACEHOLDER' | translate"
              class="h-11 pl-10 pr-4 focus:outline-none" formControlName="maxPrice">
            <div class="absolute top-1/2 -translate-y-1/2 left-2.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                <path d="M12 18V6" />
              </svg>
            </div>
          </div>
          <button type="submit" class="px-8 h-11  rounded-full bg-main-500 hover:bg-main-600 text-white text-sm">
            {{ 'HAIRSTYLES.SEARCH_BUTTON' | translate }}
          </button>
          <button type="reset" (click)="onClearForm()"
            class="px-6 h-11  rounded-full bg-gray-100 border border-gray-200 hover:bg-gray-200 text-sm">
            {{ 'HAIRSTYLES.CLEAR_BUTTON' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="bg-white py-10 lg:py-20 px-4 lg:max-w-5xl xl:max-w-6xl mx-auto">
    @if (isLoadingHairstyles()) {
    <div class="min-h-96 grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-3 lg:grid-cols-4">
      @for (item of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
      <div class="aspect-[3/4] rounded-xl bg-gray-200 animate-pulse"><span class="sr-only">{{ item }}</span></div>
      }
    </div>
    } @else if (hairstylesPaginated() == null || hairstylesPaginated()!.data.length === 0) {
    <div class="min-h-64 flex flex-col items-center justify-center">
      <div class="relative h-14 lg:h-16 w-full mb-2">
        <img ngSrc="/icons/not-found-icon.svg" alt="Not Found" fill priority class="w-14 lg:w-16">
      </div>
      <div class="text-xl font-medium">{{ 'HAIRSTYLES.NO_HAIRSTYLES_FOUND' | translate }}</div>
      <div class="text-gray-500">{{ 'HAIRSTYLES.TRY_ADJUSTING' | translate }}</div>
    </div>
    } @else {
    <div class="min-h-96 grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-3 lg:grid-cols-4">
      @for (hairstyle of hairstylesPaginated()!.data | paginate: {
      itemsPerPage: hairstylesPaginated()!.limit,
      totalItems: hairstylesPaginated()!.totalElements,
      currentPage: hairstylesPaginated()!.currentPage,
      }; track $index) {
      <a [routerLink]="['/hairstyles', toSlug(hairstyle.nom)]" class="group flex flex-col">
        <div class="relative aspect-[3/4] rounded-xl overflow-hidden bg-primary-light">
          @if (hairstyle.images?.[0]) {
            <img [ngSrc]="hairstyle.images![0]" [alt]="hairstyle.nom" fill [priority]="$index < 4"
              class="object-cover object-top group-hover:scale-[1.03] transition-transform duration-300">
          } @else {
            <!-- Sans photo : une icône discrète, et non le placeholder étiré sur toute la carte. -->
            <div class="absolute inset-0 flex items-center justify-center">
              <img [ngSrc]="HAIRSTYLE_PLACEHOLDER" [alt]="hairstyle.nom" width="56" height="56" class="size-14 opacity-30">
            </div>
          }
          <div class="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent"></div>
          @if (hairstyle.prix_moy && +hairstyle.prix_moy > 0) {
            <span class="absolute top-2 right-2 rounded-full bg-white/95 text-main-900 text-xs font-semibold px-2.5 py-1">
              {{ 'SHOP.FROM' | translate }} {{ hairstyle.prix_moy | price: 'CAD' }}
            </span>
          }
          <div class="absolute inset-x-3 bottom-3 text-white">
            <h2 class="font-semibold leading-tight">{{ hairstyle.nom }}</h2>
            @if (formatDuration(hairstyle.temps_moy)) {
              <div class="text-xs text-white/80">⏱ {{ formatDuration(hairstyle.temps_moy) }}</div>
            }
          </div>
        </div>
      </a>
      }
    </div>

    @if (hairstylesPaginated()!.totalPages > 1) {
    <pagination-controls [nextLabel]="'HAIRSTYLES.NEXT' | translate" [previousLabel]="'HAIRSTYLES.PREVIOUS' | translate"
      (pageChange)="onPageChange($event)" class="pagination" />
    }
    }
  </div>
</div>
